module.exports = __webpack_public_path__ + "img/activity3.0b69b584.jpg";